export default {"src":"/_next/static/media/mail-open.0476ce8f.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};